import React, {useEffect, useMemo} from "react";
import {useAsync} from "react-async-hook";
import {useNavigate, useParams} from "react-router-dom";
import {useSiteApi} from "../data/sites";
import {useTenant} from "../context/tenant";
import {isBlank, notBlank} from "../utils";
import {AppLayout} from "../component/app-layout";
import {OrderContextProvider, OrderStep} from "../context/order";
import {OrderProgress} from "./order/order-progress";
import {OrderFlow} from "./order/order-flow";
import {hasSimplifiedLayout} from "../booking-utils";
import {OrderFlowSimplified} from "./order/simplifed/order-flow-simplified";

export function SiteRoutes() {
	const navigate = useNavigate();
	const {tenant} = useTenant();
	const {siteId, step} = useParams<{ siteId: string, step: OrderStep }>();
	const {getSite} = useSiteApi();

	const {result: site, error, loading} = useAsync(async () =>
		(notBlank(tenant?.id) && notBlank(siteId))
			? getSite(tenant?.id as string, siteId as string)
			: undefined
		, [tenant?.id, siteId])

	const simplifiedLayout = useMemo(() =>
		hasSimplifiedLayout(site)
		, [site]);

	useEffect(() => {
		if (isBlank(step) && site !== undefined && !simplifiedLayout) {
			navigate(`/${tenant?.id}/${siteId}/dates`, { replace: true });
		}
	}, [step, site, simplifiedLayout]);

	return (
		<AppLayout
			showBrandingBar={!simplifiedLayout}
			error={error}
			loading={loading}
		>
			<OrderContextProvider>
				{site !== undefined && !simplifiedLayout && (
					<>
						<OrderProgress site={site} />
						<OrderFlow site={site} />
					</>
				)}
				{site !== undefined && simplifiedLayout && (
					<OrderFlowSimplified site={site} />
				)}
			</OrderContextProvider>
		</AppLayout>
	)
}
